/**
 * created by bennyang
 * cgi created by skycfwu
 * wiki https://iwiki.oa.tencent.com/display/TEGBPD/elec_invoice_service_front
 */
import cgiObj from "./cgi"
import { objectAssign, getParam } from "@tencent/midas-util"
import * as helper from "../utils/helper"
import * as invoiceConfig from "../constants/invoice"
import moment from "moment"
import * as request from "../utils/request"
import * as aes from "../utils/aes"
/**
 * 可开票/开票交易流水查询
 * trade_water_query
 * pageNum: 页码，从1开始（必填）
 * pageSize: 页大小，最大不超过100（必填）
 * beginTime：查询起始时间戳，不小于"2018-12-01 00:00:00", 单位s（必填）
 * endTime：查询截止时间戳，不大于当前时间，单位s（必填）
 * isSpecial：区分专票和普票
 */
export function queryTradeWater(
  enable = false,
  { pageNum = 1, pageSize = 20, beginTime, endTime, isSpecial = false, offerIds = "" }
) {
  return new Promise((resolve, reject) => {
    const params = {
      action: enable ? "to_invoice_trade_water_query" : "trade_water_query",
      pageNum: pageNum,
      pageSize: pageSize,
      beginTime: beginTime,
      endTime: endTime
    }
    if (isSpecial) {
      params.sp_filter = 1
    }
    if (offerIds) {
      params.pay_offerid_list = offerIds
    }
    cgiObj
      .request("elecInvoiceService", params)
      .then(res => {
        if (res.ret === 0) {
          let total = 0
          if (res.data && res.data.record) {
            total = res.data.record.length
            // 类别为空的过滤不展示
            res.data.record = res.data.record.filter(item => item.makeoutItemDisplay)

            // 2021年9月之前的订单默认使用旧商户号 计算机主体
            let limitTime = getTime(getMonthStartEndDay(2021, 9).start + " 00:00:00")
            let list = res.data.record.filter(item => item.payTime >= limitTime)
            if (!list.length) {
              /* 9月之前的订单有 merchantID、mainbodyName、mainbodyID 字段，但都为空值，所以直接补默认主体用来分类即可,
              提交请求时因为没有 merchantID 会判断不传 mainbodyName、mainbodyID字段 */
              res.data.record = res.data.record.map(item => {
                return {
                  ...item,
                  ...invoiceConfig.defaultMainbody
                }
              })
            } else {
              let recordItem = res.data.record.find(item => {
                return "merchantID" in item
              })
              if (recordItem) {
                res.data.record = res.data.record.filter(item => item.merchantID)
                let mainbodyItem = res.data.record.find(item => item.mainbodyID)
                if (mainbodyItem) {
                  res.data.record = res.data.record.filter(item => item.mainbodyID)
                } else {
                  // 有merchantID，没有mainbodyID
                  // 这里补充一下主体信息
                  // 补齐了这个分支，这样可以保证后续列表中展示的所有订单都有mainbodyID，后续无需再对mainbodyID为空的情况做特殊处理
                  const newRecord = []
                  res.data.record.forEach(item => {
                    const result = invoiceConfig.mainBodyList.find(mainBodyItem =>
                      mainBodyItem.mainbodyIdList.includes(item.merchantID)
                    )
                    if (result) {
                      newRecord.push({ ...item, mainbodyName: result.mainbodyName, mainbodyID: result.mainbodyID })
                    }
                  })
                  res.data.record = newRecord
                }
              } else {
                res.data.record = res.data.record.map(item => {
                  return {
                    ...item,
                    ...invoiceConfig.defaultMainbody
                  }
                })
              }
            }
          }
          resolve({ ...res.data, total })
        } else {
          reject(res)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 提交开票申请
 * commit_apply
 * orderIdList：渠道订单id列表，以";"分割，不超过30个（必填）
 * invoiceType：发票抬头类型  1-个人 2-组织 3-公司普票 4-公司专票（必填）
 * amt：发票申请金额，单位：分（严格校验，必填）
 * invoiceTitle：发票抬头名称（发票抬头类型为组织、公司时必填）
 * taxpayerId：纳税人识别号（发票抬头类型为公司时必填）
 * companyAddr：单位地址（发票抬头类型为公司时必填）
 * companyPhone：单位电话（发票抬头类型为公司时必填）
 * companyBankName：单位开户银行（发票抬头类型为公司时必填）
 * companyBankAcct：单位开户银行账号（发票抬头类型为公司时必填）
 * sendTo：邮寄收件人（公司专票时必填）
 * sendPhone：邮寄收件人手机号码（公司专票时必填）
 * sendProvince：邮寄收件人省份（公司专票时必填）
 * sendCity：邮寄收件人城市（公司专票时必填）
 * sendAddr：邮寄详细地址（公司专票时必填）
 * postalCode：邮政编码（公司专票时必填）
 *
 * 2316-提交开票申请时  开票订单金额校验不通过
 * 2318-提交开票申请时 存在已开票或开票中的订单
 * 2319-提交开票申请时 存在全额退款订单
 *
 * 2316/2319返回内容：
 {"ret":2319,"msg":"xxxx","data":{"fullRefundOrderInfo":[{"orderId":"xxxx","refundMoney":"xxxx"}],"partRefundOrderInfo":[{"orderId":"xxxx","refundMoney":"xxxx"}]}}
 fullRefundOrderInfo：全额退款订单信息
 partRefundOrderInfo：部分退款订单信息
 {"ret":2318,"msg":"xxxx","data":{"failOrderIds":["xxxx","xxxx"]}}
 */
export function commitInvoiceApply(opt) {
  return new Promise((resolve, reject) => {
    const params = {
      action: "commit_apply"
    }
    opt = objectAssign(params, opt || {})
    cgiObj
      .request("elecInvoiceService", opt)
      .then(res => {
        if (res.ret === 0) {
          resolve(res.data)
        } else {
          reject(res)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 开票流水查询
 * invoice_water_query
 * pageNum: 页码，从1开始（必填）
 * pageSize: 页大小，最大不超过100（必填）
 * beginTime：查询起始时间戳，不小于"2018-12-01 00:00:00", 单位s（必填）
 * endTime：查询截止时间戳，不大于当前时间，单位s（必填）
 */
export function queryInvoiceRecords({ pageNum = 1, pageSize = 10, offerIds = "" }) {
  return new Promise((resolve, reject) => {
    const params = {
      action: "invoice_water_query",
      pageNum: pageNum,
      pageSize: pageSize,
      beginTime: getTime(invoiceConfig.staticConfig.invoiceBeginTime),
      endTime: getTime()
    }
    if (offerIds) {
      params.pay_offerid_list = offerIds
    }
    cgiObj
      .request("elecInvoiceService", params)
      .then(res => {
        if (res.ret === 0) {
          resolve(res.data)
        } else {
          reject(res)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 开票详细信息查询
 * invoice_detail_query
 * invoiceOrderId：内部开票申请单号（必填）
 */
export function queryInvoiceDetail(orderId) {
  return new Promise((resolve, reject) => {
    const params = {
      action: "invoice_detail_query",
      invoiceOrderId: orderId
    }
    cgiObj
      .request("elecInvoiceService", params)
      .then(res => {
        if (res.ret === 0) {
          resolve(res.data)
        } else {
          reject(res)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 查询个人缓存抬头及邮寄信息
export function queryPersonalTitle() {
  return new Promise((resolve, reject) => {
    const params = {
      action: "query_personal_title"
    }
    cgiObj
      .request("elecInvoiceService", params)
      .then(res => {
        if (res.ret === 0) {
          if (res.data && res.data.record) {
            resolve(res.data.record[0])
          }
          resolve({})
        } else {
          reject(res)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 替换个人缓存抬头及邮寄信息
export function replacePersonalTitle(opt) {
  return new Promise((resolve, reject) => {
    const params = {
      action: "replace_personal_title"
    }
    let paramsList = [...invoiceConfig.invoiceTitleFiled.special, ...invoiceConfig.invoiceTitleFiled.specialTitle].map(
      item => item.key
    )
    paramsList = Array.from(new Set(paramsList))
    paramsList.map(item => {
      params[item] = opt[item]
    })
    cgiObj
      .request("elecInvoiceService", params)
      .then(res => {
        if (res.ret === 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 附件上传
export function upload(params) {
  return new Promise((resolve, reject) => {
    let env = ""
    if (getParam("sandbox") == 1) {
      env = "sandbox."
    }
    if (getParam("sandbox") == 2) {
      env = "dev."
    }
    if (getParam("sandbox") == 3) {
      env = "testing."
    }

    let url = `https://${env}api.unipay.qq.com/cgi-bin/inv_forward.fcg`
    let data = {
      request: {
        appId: "4333",
        name: params.name
      },
      data: params.data.split(",")[1],
      openid: params.openid.toString(),
      openkey: params.openkey,
      session_id: params.session_id,
      session_type: params.session_type
    }

    data = Object.assign(
      data,
      aes.encrypt(data, ["openid", "openkey", "session_id", "session_type"], getParam("sandbox"))
    )
    request
      .ajax({
        url: url,
        data: data,
        type: "POST",
        contentType: "json",
        requestContentType: "application/json"
      })
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 获取时间（单位s）
 * @param time format 2019/04/02 00:00:00
 * @returns {number}
 */
// export const getTime = (time = new Date()) => {
//   return Date.parse(time) / 1000
// }

export const getTime = time => {
  let date = time ? new Date(time.replace(/-/g, "/")) : new Date()
  return parseInt(date.getTime() / 1000)
}

/**
 * 获取当天时间 2019-04-02
 * @returns {string}
 */
export function getToday() {
  return moment(new Date()).format("YYYY-MM-DD")
}

/**
 * 获取一年前的时间
 * @returns {string}
 */
export function getYearAgoDay() {
  let yearAgo = moment()
    .subtract(31536000000, "milliseconds")
    .add(1, "days")
    .format("YYYY-MM-DD")
  if (new Date(invoiceConfig.staticConfig.allBeginTime.replace(/-/g, "/")) >= new Date(yearAgo)) {
    return invoiceConfig.staticConfig.allBeginTime
      .replace(/-/g, "/")
      .split(" ")[0]
      .replace(/\//g, "-")
  } else {
    return yearAgo
  }
}

/**
 * 获取N年前的时间
 * @returns {string}
 */
export function getNYearAgoDay(n = 1, limitTime) {
  return invoiceConfig.staticConfig.allBeginTime
    .replace(/-/g, "/")
    .split(" ")[0]
    .replace(/\//g, "-")

  // 注释：这里这么改动的原因是因为时间查询这里改过很多版，从开始固定时间，到几年动态时间，再到现在固定2017-01-01时间，所以这里直接改一个地方，省的到处改
  // let nYearAgo = moment()
  //   .subtract(n, "years")
  //   .add(1, "days")
  //   .format("YYYY/MM/DD")
  // if (limitTime && new Date(limitTime.replace(/-/g, "/")) >= new Date(nYearAgo)) {
  //   return limitTime
  //     .replace(/-/g, "/")
  //     .split(" ")[0]
  //     .replace(/\//g, "-")
  // } else {
  //   return nYearAgo
  // }
}

/**
 * 获取两年前的月头时间，例如：2020/01/01
 * @returns {string}
 */
export function getTwoYearAgoDay() {
  let yearAgo = moment()
    .add(-23, "M")
    .startOf("month")
    .format("YYYY/MM/DD")
  return yearAgo
}

/**
 * 获取两年前的月头时间文字
 * @returns 例如：2020年01月01日
 */
export function getTwoYearAgoDayFormat() {
  let yearAgo = moment()
    .add(-23, "M")
    .startOf("month")
    .format("YYYY年MM月DD日")

  return yearAgo
}

/**
 * 格式化日期
 * @returns 例如：2020年01月01日
 */
export function getNYearAgoDayFormat(date) {
  let yearAgo = moment(date).format("YYYY年MM月DD日")
  return yearAgo
}

/**
 * 获取三个月前的时间
 * @returns {string}
 */
export function getThreeMonthAgoDay() {
  let yearAgo = moment()
    .subtract(3, "months")
    .format("YYYY-MM-DD")
  if (new Date(invoiceConfig.staticConfig.allBeginTime.replace(/-/g, "/")) >= new Date(yearAgo)) {
    return invoiceConfig.staticConfig.allBeginTime
      .replace(/-/g, "/")
      .split(" ")[0]
      .replace(/\//g, "-")
  } else {
    return yearAgo
  }
}

/**
 * 获取指定月份的第一天和最后一天
 * @param {*} year number
 * @param {*} month number
 * @returns {string} YYYY-MM-DD
 */
export function getMonthStartEndDay(year, month) {
  let end = moment()
    .year(year)
    .month(month - 1)
    .endOf("month")
    .format("YYYY-MM-DD")
  if (new Date() < new Date(end)) {
    end = moment().format("YYYY-MM-DD")
  }
  return {
    start: moment()
      .year(year)
      .month(month - 1)
      .startOf("month")
      .format("YYYY-MM-DD"),
    end: end
  }
}

export function fetchWithAbort(fetchPromise) {
  let abort = null
  const abortPromise = new Promise((resolve, reject) => {
    abort = () => {
      reject("abort")
    }
  })
  let promiseWithAbort = Promise.race([fetchPromise, abortPromise])
  promiseWithAbort.abort = abort
  return promiseWithAbort
}

export const classify = selectedInvoice => {
  const mainbodyMap = {}
  // 先分主体
  selectedInvoice.forEach(item => {
    if (!item.mainbodyID) return
    if (!mainbodyMap[item.mainbodyID]) {
      mainbodyMap[item.mainbodyID] = [item]
    } else {
      mainbodyMap[item.mainbodyID].push(item)
    }
  })

  const invoiceList = []

  // 再分结算组类别
  for (const key in mainbodyMap) {
    let list = []
    mainbodyMap[key].forEach(item => {
      const result = list.find(listItem => listItem.makeoutItemDisplay === item.makeoutItemDisplay)
      if (!result) {
        list.push({
          makeoutList: [item],
          makeoutItemDisplay: item.makeoutItemDisplay,
          mainbodyName: item.mainbodyName,
          mainbodyID: item.mainbodyID,
          key: item.makeoutItemDisplay + "_" + item.mainbodyID
        })
      } else {
        result.makeoutList.push(item)
      }
    })

    invoiceList.push(...list)
  }
  return invoiceList
}

/*  处理分主体数据Info, 并计算每个主体的金额等
 * @param {*} 需要处理的list
 * @param {*} 开票失败的发票list
 */
export const handleClassificationListInfo = (selectInvoiceClassification, failedInvoiceList = []) => {
  let newSelectInvoiceClassification = selectInvoiceClassification.map(classificationItem => {
    let totalPrice = 0
    let totalOriginPrice = 0
    let selectedInvoiceCftIds = []
    let data = {}
    classificationItem.makeoutList &&
      classificationItem.makeoutList.map(item => {
        totalPrice += item.payAmt * 1
        totalOriginPrice += item.payAmt * 1
        if (item.partRefundAmt) {
          totalPrice -= item.partRefundAmt
        }
        !failedInvoiceList.length && selectedInvoiceCftIds.push(item.cftId)
      })
    let item =
      (failedInvoiceList.length &&
        failedInvoiceList.filter(
          item =>
            item.mainbodyID === classificationItem.mainbodyID &&
            item.makeoutItemDisplay === classificationItem.makeoutItemDisplay
        )[0]) ||
      {}

    data = {
      ...classificationItem,
      selectedInvoiceCftIds,
      invoiceTotalPrice: item.invoiceTotalPrice || totalPrice,
      invoiceTotalOriginPrice: item.invoiceTotalOriginPrice || totalOriginPrice
    }
    if (failedInvoiceList.length) delete data.selectedInvoiceCftIds
    return data
  })
  return newSelectInvoiceClassification
}

/**
 * 发送发票至邮箱
 */
export function sendEmail(data) {
  const env = helper.getEnv(getParam("sandbox"))
  const url = `https://${env}api.unipay.qq.com/cgi-bin/apply_delivery_invoice_email.fcg`
  return new Promise((resolve, reject) => {
    request
      .ajax({
        url,
        data: data,
        type: "POST",
        contentType: "json",
        requestContentType: "application/json"
      })
      .then(res => {
        if (res.ret === 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}
